import { Component, OnInit, ViewContainerRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { StationService } from '../../_services/fundraising/station.service';
import { PosStation } from '../../_models/fundraising/PosStation';
import { NgxSpinnerService } from 'ngx-spinner';
import { DialogService } from '../../_services/dialog.service';

@Component({
    selector: 'app-station-create',
    templateUrl: './station-create.component.html',
    styleUrls: ['./station-create.component.css']
})

export class StationCreateComponent implements OnInit  {

    public stationForm: FormGroup;

    public stationId: number;
    public station: PosStation;

    public stationFC(name: string)  {
        return this.stationForm?.controls[name];
    }

    public locationFC(name: string)  {
        return (this.stationForm.controls['location'] as FormGroup)?.controls[name];
    }

    constructor(
        private stationService: StationService,
        private route: ActivatedRoute,
        private router: Router,
        private spinner: NgxSpinnerService,
        private dialogService: DialogService,
        private viewRef: ViewContainerRef,
        private fb: FormBuilder
    ) { }

    ngOnInit(): void {
        this.spinner.show();

        this.route.params
        .subscribe(params => {
          this.stationId = params['id'] ?? 0;
            this.stationService.getById(this.stationId)
                .subscribe(l => {
                    this.station = l;

                    this.createForm(this.station);

                    this.spinner.hide();

                },
                error => {
                    this.dialogService.alert("Oops something went wrong...", error.error, this.viewRef);
                    this.spinner.hide();
                }
            )
        });
    }

    createForm(station: PosStation) {
        this.stationForm = this.fb.group({
            stationId: [station?.stationId || 0, Validators.required],
            name: [station?.name, Validators.required],
            description: [station?.description, Validators.required],
            allowGuests: [station?.allowGuests || false, Validators.required],
        });

    }

    hasStationErrors() {
        return this.stationForm && !this.stationForm.valid && this.stationForm.touched;
    }

    hasLocationErrors() {
        return this.stationForm && this.stationForm.controls.location && this.stationForm.controls.location.touched && this.stationForm.controls.location.invalid;
    }

    save() {

        const invalid = [];
        const controls = this.stationForm.controls;
        for (const name in controls) {
            if (controls[name].invalid) {
                invalid.push(name);
            }
        }
        if (this.hasStationErrors() || this.hasLocationErrors()) {
          this.stationForm.markAllAsTouched();
          this.stationForm.markAsDirty();

          this.stationForm.controls.location.markAllAsTouched();
          this.stationForm.controls.location.markAsDirty();
          return;
        }

        this.spinner.show();

        const stationData = new PosStation(this.stationForm.getRawValue());

        if(this.stationId > 0) {
            this.stationService.update(stationData).subscribe(
              () => {
                this.spinner.hide();
                this.navigateUp();
              },
              error => {
                this.spinner.hide();
                this.dialogService.error(error, 'Unable to update station', this.viewRef);
              }
            );
          } else {
            this.stationService.create(stationData).subscribe(
              () => {
                this.spinner.hide();
                this.navigateUp();
              },
              error => {
                this.spinner.hide();
                this.dialogService.error(error, 'Unable to create station', this.viewRef);
              }
            );
          }

    }

    openStationInfo() {
        this.dialogService.alert('Stations Stations Stations',
        'Station Stations are the feet on the ground selling tickets during your event.', this.viewRef, 'Ok');
    }


    public  navigateUp() {
        this.router.navigate([this.stationId > 0 ? '../../' : '../'], {relativeTo: this.route});
      }


}
